import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { SessionStorageService } from 'ngx-webstorage'; 
@Component({
  selector: 'cbic-taxpayer',
  templateUrl: './taxpayer.component.html',
  styleUrls: ['./taxpayer.component.scss']
})
export class TaxpayerComponent implements OnInit {

  tradwDataList?: ICbicContentMst[];
  reportDataList?: ICbicContentMst[];
  citizenDataList?: ICbicContentMst[];
  stackeholderyDataList?: ICbicContentMst[];
  otherDataList?: ICbicContentMst[];
  contactDataList?: ICbicContentMst[];
  flag : any ;
  color:any;
  constructor(private sessionStorageService: SessionStorageService,private contentMstService : CbicContentMstService,private changeLnService: ChangeLanguageService) { }

  isDataAvailable() {
    let dataAvailable = true;
    dataAvailable &&= this.tradwDataList != null && this.tradwDataList.length !== 0;
    if (dataAvailable) {
      dataAvailable &&= this.reportDataList != null && this.reportDataList.length !== 0;
    }
    // if (dataAvailable) {
    //   dataAvailable &&= this.citizenDataList != null && this.citizenDataList.length !== 0;
    // }
    if (dataAvailable) {
      dataAvailable &&= this.stackeholderyDataList != null && this.stackeholderyDataList.length !== 0;
    }
    if (dataAvailable) {
      dataAvailable &&= this.otherDataList != null && this.otherDataList.length !== 0;
    }
    if (dataAvailable) {
      dataAvailable &&= this.contactDataList != null && this.contactDataList.length !== 0;
    }
    return dataAvailable;
  };

  ngOnInit(): void {

    this.gettradeData();
    this.getreportData();
    this.getstackholderData();
    this.getcontactData();
    this.OtherDataList();
    this.getSuggestion();
    this.color = this.sessionStorageService.retrieve('colr');

  }

  gettradeData() :void{
    this.contentMstService.getContentData('Trade-taxpayer').subscribe(
      (res : HttpResponse<ICbicContentMst[]>) => {
        if(res.body){
          const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
          this.tradwDataList = res.body;
        }
      }
    )
}

getreportData() :void{
  this.contentMstService.getContentData('Report-taxpayer').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
        this.reportDataList = res.body;
      }
    }
  )
}

getSuggestion() :void{
  this.contentMstService.getContentData('Suggestions-from-Trade').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
        this.citizenDataList = res.body;
      }
    }
  )
}

getstackholderData() :void{
  this.contentMstService.getContentData('Stackeholder-taxpayer').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
        this.stackeholderyDataList = res.body;
      }
    }
  )
}

getcontactData() :void{
  this.contentMstService.getContentData('Contact-taxpayer').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
        this.contactDataList = res.body;
      }
    }
  )
}

OtherDataList() :void{
  this.contentMstService.getContentData('Other-taxpayer').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
        this.otherDataList = res.body;
      }
    }
  )
}

}
